




































export default {
  name: "Loading",
  props: { name: "class", type: Array(), default: () => [] },
};
